import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'entities/Auth';

import { LanguageEnum, LanguageFullNameEnum, LANGUAGES_FLAGS } from 'utils/constants';

interface ILanguageItem {
  lang: LanguageEnum;
  fullname: LanguageFullNameEnum;
}
const LanguageItem = ({ lang, fullname }: ILanguageItem) => {
  const { i18n } = useTranslation();
  const { updateUserLanguage } = useAuth();

  const flagImg = useMemo(() => {
    return LANGUAGES_FLAGS[lang];
  }, [lang]);

  const languageOnClick = useCallback(() => {
    // TODO: process loading state
    updateUserLanguage(lang);
  }, [lang, updateUserLanguage]);

  return (
    <div
      className={`w-full rounded-[4px] px-[10px] py-[4px] flex items-center gap-[6px] cursor-pointer hover:bg-beige ${lang === i18n.language ? 'bg-beige pointer-events-none' : ''}`}
      onClick={languageOnClick}
    >
      <img src={flagImg} className='w-[16px] h-[16px] rounded-[50%]' />
      <div className='text-grey500 font-[MuseoSans900] tracking-[1.5px]'>{fullname}</div>
    </div>
  );
};

export default LanguageItem;
